// extracted by mini-css-extract-plugin
export default {"card":"ImageAdCard_card__Dpjvd"};